var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"table-footer text-muted small px-2 py-1"},[_vm._v(" "+_vm._s(_vm.displayedCount)+" Zeilen dargestellt, "+_vm._s(_vm.selectedCount)+" Zeilen ausgewählt. ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }